import { render, staticRenderFns } from "./LinkInstagram.vue?vue&type=template&id=271d8dca&scoped=true&"
import script from "./LinkInstagram.vue?vue&type=script&lang=js&"
export * from "./LinkInstagram.vue?vue&type=script&lang=js&"
import style0 from "./LinkInstagram.vue?vue&type=style&index=0&id=271d8dca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271d8dca",
  null
  
)

export default component.exports